module.exports = __webpack_public_path__ + "static/img/wealth_level_59.d88aaa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_59.png
// module id = Xi7n
// module chunks = 0